import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { ServiceapiService } from "src/app/serviceapi.service";
import { Observable } from "rxjs/internal/Observable";
// import * as alertifyjs from "alertifyjs"; // Removed alertifyjs import
import * as saveAs from "file-saver";

@Component({
  selector: "app-admitcard",
  templateUrl: "./admitcard.component.html",
  styleUrls: ["./admitcard.component.scss"],
})
export class AdmitcardComponent implements OnInit {
  form: FormGroup;
  otpSent: boolean = false;
  otpVerified: boolean = false;
  loading: boolean = false;
  studentId: string | null = null;
  rollNo: string | null = null;

  // Custom Alert State
  showAlert: boolean = false;
  alertMessage: string = "";
  alertType: "success" | "error" = "success"; // Controls background color
  recruitmentList: any[] = [];
  

  // FIX: Changed from 'private' to 'public' so the HTML template can access it for display.
  public readonly DUMMY_OTP = "123456";
  rows: any;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private serviceapi: ServiceapiService
  ) {
    this.form = this.fb.group({
      recruitmentId: ["", Validators.required],
      mobile: ["", [Validators.required, Validators.pattern("^[0-9]{10}$")]],
      otp: [""],
    });
  }

  ngOnInit(): void {
    // Alertify setup removed.
    this.loadRecruitmentDetails();
  }

  // New method to handle custom alert display
  showCustomAlert(message: string, type: "success" | "error"): void {
    this.alertMessage = message;
    this.alertType = type;
    this.showAlert = true;

    // Automatically hide the alert after 3 seconds
    setTimeout(() => {
      this.showAlert = false;
    }, 3000);
  }
  //get recruitment post details for dropdown
  loadRecruitmentDetails(): void {
    this.serviceapi.getRecruitmentpostDetails().subscribe({
      next: (res: any) => {
        // Based on your JSON response structure: res.body.details
        this.recruitmentList = res.body?.details || [];
      },
      error: (err) => {
        console.error("Failed to load recruitment names", err);
        this.showCustomAlert("Could not load recruitment list", "error");
      }
    });
  }

  // Handle mobile input - allow only numbers and max 10 digits
  onMobileInput(event: any): void {
    let value = event.target.value;
    // Remove all non-numeric characters
    value = value.replace(/[^0-9]/g, '');
    // Limit to 10 digits
    value = value.substring(0, 10);
    // Update the form control
    this.form.get('mobile')?.setValue(value, { emitEvent: false });
  }

  getOtp(): void {
    if (this.form.get("mobile")?.invalid) {
      this.form.get("mobile")?.markAsTouched();
      return;
    }

    const mobile = this.form.get("mobile")?.value;
    const recruitmentConfig = this.form.get("recruitmentId")?.value;
    this.loading = true;

    this.serviceapi.sendOtp(mobile,recruitmentConfig).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.status === "1") {
          this.otpSent = true;
          // // 🔒 Make mobile field uneditable
          this.form.get('mobile')?.disable();
          this.rollNo = res.rollNo || null;
          this.showCustomAlert(
            res.message || "OTP sent successfully.",
            "success"
          );
        } else {
          this.showCustomAlert(res.message || "Failed to send OTP.", "error");
        }
      },
      error: (err) => {
        this.loading = false;
        console.error("OTP send failed:", err);
        this.showCustomAlert(
          "Failed to send OTP. Please try again later.",
          "error"
        );
      },
    });
  }

  verifyOtp(): void {
    if (this.form.get("otp")?.invalid || this.form.get("mobile")?.invalid) {
      this.form.get("otp")?.markAsTouched();
      this.form.get("mobile")?.markAsTouched();
      return;
    }

    const mobile = this.form.get("mobile")?.value;
    const otp = this.form.get("otp")?.value;
    const recruitmentConfig = this.form.get("recruitmentId")?.value;
    this.loading = true;

    this.serviceapi.verifyOtp(mobile,otp,recruitmentConfig).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.status === "1") {
          this.otpVerified = true;

          // ✅ Use encryptedRollNo as studentId for report generation
          this.studentId = res.encriptedRollNo;

          console.log("OTP verified successfully. Student ID:", this.studentId);
          this.showCustomAlert("OTP verified successfully!", "success");
        } else {
          this.showCustomAlert(
            res.message || "Invalid OTP. Please try again.",
            "error"
          );
        }
      },
      error: (err) => {
        this.loading = false;
        console.error("OTP verification failed:", err);
        this.showCustomAlert(
          "Failed to verify OTP. Please try again later.",
          "error"
        );
      },
    });
  }

  public generateCandidateCallLetter(body: {
    studentId: string;
    reportType: string;
  }): Observable<any> {
    return this.serviceapi.generateCandidateCallLetter(body);
  }

  /**
   * Initiates the download process for a specific report type.
   * @param reportType 'admitcard', 'callletter', or 'instruction'.
   */

  public currentReport: string | null = null;

  public generateReport(
    reportType: "admitcard" | "callletter" | "instruction"
  ): void {
    if (!this.studentId) {
      this.showCustomAlert(
        "Please verify OTP before proceeding to download.",
        "error"
      );
      return;
    }

    this.loading = true;
    this.currentReport = reportType;

    const body = { studentId: this.studentId!, reportType };

    this.generateCandidateCallLetter(body).subscribe({
      next: (response: HttpResponse<Blob>) => {
        this.loading = false;
        this.currentReport = null;

        const contentType = response.headers.get("Content-Type");
        if (contentType && contentType.includes("application/pdf")) {
          const blob = response.body!;
          const fileName = `${reportType}_${this.rollNo}.pdf`;
          saveAs(blob, fileName);
          this.showCustomAlert("File downloaded successfully", "success");
        } else {
          this.readJsonFromBlob(response.body!);
        }
      },
      error: (error: any) => {
        this.loading = false;
        this.currentReport = null;
        console.error("Download failed:", error);
        this.showCustomAlert(
          "Failed to generate report. Please try again later.",
          "error"
        );
      },
    });
  }

  /**
   * Reads and parses a Blob as JSON, then shows its message.
   */
  private readJsonFromBlob(blob: Blob): void {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const json = JSON.parse(reader.result as string);
        const message = json.message || "No report available.";
        this.showCustomAlert(
          message,
          json.status === "2" ? "success" : "error"
        );
      } catch (err) {
        console.error("Invalid JSON response:", err);
        this.showCustomAlert("Unexpected response from server.", "error");
      }
    };
    reader.readAsText(blob);
  }
}
